export enum ProofOfAddressType {
  Light,
  Water,
  Gas,
  Telephone,
  Internet,
  TelevisionService,
  BankStatement,
  INE,
}

export const proofOfAddressTypeValues: { [id: number]: string } = {
  0: 'Luz',
  1: 'Agua',
  2: 'Gas',
  3: 'Teléfono',
  4: 'Internet',
  5: 'Servicio de televisión',
  6: 'Estado de cuenta bancario',
  7: 'INE',
};

export namespace ProofOfAddressType {
  export function items() {
    var items = Object.keys(ProofOfAddressType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: proofOfAddressTypeValues[index], value: index };
      });

    return items.filter((x) => x.key != undefined);
  }
}
